"use strict";const s=["disabled","title","hidden","role","draggable"],r=e=>s.includes(e)||e.startsWith("aria")?!0:![HTMLElement,Element,Node].some(t=>t.prototype.hasOwnProperty(e));export default r;
//# sourceMappingURL=isValidPropertyName.js.map
